// Single source of truth for template metadata. Imported by TemplateSelector
// (the dedicated picker page) and TemplatePreviewCarousel (the home-page
// rotating preview) so they stay in sync.

export const TEMPLATES = [
  {
    key: 'modern',
    label: 'Modern',
    description: 'Clean single-column with a slate accent. ATS-friendly default for most roles.',
    bestFor: 'Tech · Business · Operations'
  },
  {
    key: 'executive',
    label: 'Executive',
    description: 'Refined Georgia serif, centered name, italicized profile. Conservative and senior.',
    bestFor: 'Senior · Finance · Legal · Consulting'
  },
  {
    key: 'tech',
    label: 'Tech',
    description: 'Bold cyan header bar, monospaced section labels, skill pills. Built for engineers.',
    bestFor: 'Engineering · Product · DevOps'
  },
  {
    key: 'academic',
    label: 'Academic',
    description: 'Traditional Times Roman CV. Centered name, sectioned for research and teaching.',
    bestFor: 'PhD · Research · Faculty · Grants'
  },
  {
    key: 'creative',
    label: 'Creative',
    description: 'Sand-tone sidebar with burnt-orange accent. Personality without sacrificing readability.',
    bestFor: 'Design · Marketing · Brand'
  },
  {
    key: 'compact',
    label: 'Compact',
    description: 'Dense single-column with deep blue accent. Fits ~30% more content on one page.',
    bestFor: 'Long careers · Senior IC roles'
  }
];

// Sample data used in preview cards. Designed to exercise every section so
// templates show their best face. No PII — totally fictional.
export const SAMPLE_RESUME_DATA = {
  fullName: 'Alex Johnson',
  jobTitle: 'Senior Software Engineer',
  email: 'alex.johnson@email.com',
  phone: '(555) 123-4567',
  linkedin: 'linkedin.com/in/alexjohnson',
  portfolio: 'alexjohnson.dev',
  summary:
    'Senior software engineer with 7+ years building scalable web applications. Track record of leading cross-functional teams to ship customer-facing products that have served 100K+ users. Passionate about clean architecture, performance, and mentorship.',
  skills:
    'JavaScript, TypeScript, React, Node.js, Python, PostgreSQL, AWS, Docker, Kubernetes, CI/CD, System Design',
  experience:
    'Senior Software Engineer · TechCorp · 2022–Present\n• Led migration of monolith to microservices, cutting p95 latency 38%\n• Mentored 4 junior engineers; 3 promoted within 18 months\n• Owned customer-facing dashboard serving 120K MAU\n\nSoftware Engineer · StartupCo · 2019–2022\n• Built event-driven payment pipeline processing $4M/mo\n• Reduced infra spend 22% via right-sizing and reserved instances\n• Shipped 2 customer-requested features quoted as quarter-ending priorities',
  education:
    'B.S. Computer Science · State University · 2019\nMagna Cum Laude · GPA 3.8/4.0',
  certifications:
    'AWS Certified Solutions Architect — Associate (2023)\nGoogle Cloud Professional Cloud Developer (2022)',
  languages: 'English (Native)\nSpanish (Conversational)'
};
